import React from 'react';
import twentyfourLogo from '../../logos/feature icons/24_7.png';
import multilingualLogo from '../../logos/feature icons/multilingual.png';
import voiceVisionLogo from '../../logos/feature icons/voice_vision.png';
import personalizableLogo from '../../logos/feature icons/personalizable.png';
import seamlessIntegrationLogo from '../../logos/feature icons/seamless_integration.png';
import alwaysImprovingLogo from '../../logos/feature icons/always_improving.png';
import intelligentHandoffLogo from '../../logos/feature icons/intelligent_handoff.png';
import systemActionsLogo from '../../logos/feature icons/system_actions.png';

const FeatureItem = ({ icon, title, description, comingSoon }) => (
  <div className={`feature-item ${comingSoon ? 'coming-soon' : ''}`}>
    <img src={icon} alt={title} className="feature-icon" />
    <h3>{title}</h3>
    <p>{description}</p>
    {comingSoon && <span className="coming-soon-label">Coming Soon</span>}
  </div>
);

const Features = () => {
  const currentFeatures = [
    { icon: multilingualLogo, title: 'Multilingual', description: 'Interacts fluently in 10+ languages' },
    { icon: personalizableLogo, title: 'Personalizable and Adaptable', description: 'Follows your rules and can adapt to new situations' },
    { icon: voiceVisionLogo, title: 'Voice and vision enabled', description: 'Speak, send images, just like you normally would' },
    { icon: twentyfourLogo, title: 'Available 24x7', description: 'Instant answers, any time, no holds' },
  ];

  const upcomingFeatures = [
    { icon: seamlessIntegrationLogo, title: 'Seamless Integration', description: 'Works with your existing CRM systems like Salesforce, Zendesk, Intercom.' },
    { icon: alwaysImprovingLogo, title: 'Always Improving', description: 'Learns from new information and cases' },
    { icon: intelligentHandoffLogo, title: 'Intelligent Handoff', description: 'Knows when to involve human experts' },
    { icon: systemActionsLogo, title: 'System Actions', description: 'Interfaces with company tools to take action' },
  ];

  return (
    <section className="features" id="features">
      <h2>Features</h2>
      <div className="feature-grid">
        {currentFeatures.map((feature, index) => (
          <FeatureItem key={index} {...feature} />
        ))}
      </div>
      <h3 className="upcoming-features-title"></h3>
      <div className="feature-grid upcoming-features">
        {upcomingFeatures.map((feature, index) => (
          <FeatureItem key={index} {...feature} comingSoon={true} />
        ))}
      </div>
    </section>
  );
};

export default Features;

// TODO: Consider adding more detailed descriptions for each feature
// TODO: Implement internationalization for feature titles and descriptions
// TODO: Add animations or transitions for feature cards on scroll or hover
// TODO: Implement a modal or expandable view for more detailed feature information